import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useCallback, useMemo } from 'react';
import { isEmptyArray, take } from '@remirror/core';
import { EmojiExtension } from '@remirror/extension-emoji';
import { useHelpers, useExtension } from '@remirror/react-core';
import { u as useMenuNavigation } from '../../dist/use-menu-navigation-2a6e1dfb.browser.esm.js';
import '@babel/runtime/helpers/createForOfIteratorHelper';
import 'multishift';
import '../../use-keymap/dist/remirror-react-hooks-use-keymap.browser.esm.js';
import '../../use-keymaps/dist/remirror-react-hooks-use-keymaps.browser.esm.js';

var emptyEmoji = [];
/**
 * This hook provides the state for setting up an emoji state change handler. It
 * applies the keybindings and the required change handlers.
 */

function useEmoji() {
  var _state$list;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var direction = props.direction,
      dismissKeys = props.dismissKeys,
      focusOnClick = props.focusOnClick,
      submitKeys = props.submitKeys;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var helpers = useHelpers();
  var items = (_state$list = state === null || state === void 0 ? void 0 : state.list) !== null && _state$list !== void 0 ? _state$list : emptyEmoji;
  var isOpen = !!state;
  var onDismiss = useCallback(() => {
    if (!state) {
      return false;
    } // Ignore the current mention so that it doesn't show again for this
    // matching area


    helpers.getSuggestMethods().addIgnored({
      from: state.range.from,
      name: 'emoji',
      specific: true
    });
    setState(null);
    return true;
  }, [helpers, state]);
  var onSubmit = useCallback(emoji => {
    if (!state || isEmptyArray(state.list)) {
      return false;
    }

    state.apply(emoji.emoji);
    return true;
  }, [state]);
  var menu = useMenuNavigation({
    items,
    isOpen,
    onDismiss,
    onSubmit,
    direction,
    dismissKeys,
    focusOnClick,
    submitKeys
  });
  var setIndex = menu.setIndex;
  var onChange = useCallback(props => {
    var change = props.change,
        exit = props.exit,
        query = props.query,
        moji = props.moji,
        _apply = props.apply,
        range = props.range;

    if (change) {
      setIndex(0);
      setState({
        list: take(moji.search(query), 20).map(emoji => _objectSpread(_objectSpread({}, emoji), {}, {
          url: moji.url(emoji)
        })),
        apply: code => {
          setState(null);
          return _apply(code);
        },
        range,
        query
      });
    }

    if (exit) {
      setState(null);
    }
  }, [setIndex]); // Add the change handler to the emoji state.

  useExtension(EmojiExtension, _ref => {
    var addHandler = _ref.addHandler;
    return addHandler('suggestEmoji', onChange);
  }, [onChange]);
  return useMemo(() => _objectSpread(_objectSpread({}, menu), {}, {
    state
  }), [menu, state]);
}

export { useEmoji };
